/* sz-customall-price.js — AI Agent làm theo chỉ thị của anh Hoá — 2026-10-15 VN — WEB-20261015-suzitee-customall-price
   Đã làm: SDK Customall in nhãn "NN% OFF"; đổi chữ thành "Save NN%" cho khớp Customily. Observer HẸP (.product-block--price), rAF, chỉ ghi khi chữ khác (không loop). Chỉ đổi text, không đụng số giá. */
(function () {
  var box = null, sched = 0, mo = null;
  function fix() {
    sched = 0;
    var els = document.querySelectorAll('.product-block--price .price__saving');
    for (var i = 0; i < els.length; i++) {
      var m = /^\s*(\d+(?:\.\d+)?)%\s*OFF\s*$/i.exec(els[i].textContent);
      if (m) els[i].textContent = 'Save ' + m[1] + '%';
    }
  }
  function kick() { if (!sched) sched = requestAnimationFrame(fix); }
  function attach() {
    var b = document.querySelector('.product-block--price');
    if (!b) return false;
    if (b !== box) { if (mo) mo.disconnect(); box = b; mo = new MutationObserver(kick); mo.observe(b, { childList: true, subtree: true, characterData: true }); }
    kick(); return true;
  }
  function start() {
    var parent = document.querySelector('.product__details--product-page') || document.body;
    var po = new MutationObserver(function () { attach(); });
    po.observe(parent, { childList: true });
    attach();
    setTimeout(function () { po.disconnect(); }, 20000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
